import { getCountryForTimezone } from "countries-and-timezones";
import { defaultCountries, parseCountry } from "react-international-phone";

/* The country this device is in, as an ISO2 code the phone field understands: the device time zone first, then the
   browser language region, then Kenya. Nothing is sent anywhere. */
const known = new Set(defaultCountries.map((c) => parseCountry(c).iso2));

export function detectCountry() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const fromTz = tz && getCountryForTimezone(tz) && getCountryForTimezone(tz).id.toLowerCase();
    if (fromTz && known.has(fromTz)) return fromTz;
    for (const lang of navigator.languages || [navigator.language]) {
      const region = (lang.split("-")[1] || "").toLowerCase();
      if (region && known.has(region)) return region;
    }
  } catch (e) { /* fall through */ }
  return "ke";
}

export const PREFERRED = ["ke", "tz", "ug", "rw", "et", "cd", "mz", "ls", "gh", "ng", "za", "eg"];
